__turbopack_context__.v({
  "linksWrapper": "navsearch-module-scss-module__E9DH8G__linksWrapper",
  "searchContainer": "navsearch-module-scss-module__E9DH8G__searchContainer",
  "searchQuickLinksHeading": "navsearch-module-scss-module__E9DH8G__searchQuickLinksHeading",
  "suggestionsWrapper": "navsearch-module-scss-module__E9DH8G__suggestionsWrapper",
});
